import { ApplicationInsights } from "@microsoft/applicationinsights-web";

if (!window.appInsights) {
    window.appInsights = new ApplicationInsights({
        config: {
            connectionString: process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING,
            enableAutoRouteTracking: true,
            disableAjaxTracking: true,
            disableFetchTracking: true
        }
    });

    window.appInsights.loadAppInsights();
}

export const initializeAppInsights = () => {
    window.appInsights.trackPageView();
};

export const overrideConsoleError = () => {
    const logError = (function (oldErrorFunction) {
        return (message, ...data) => {
            if (!message["$$typeof"]) {
                oldErrorFunction(message, ...data);
                try {
                    if (message instanceof Error) {
                        window.appInsights.trackException({
                            exception: message
                        });
                    } else {
                        const dataPoints = data.map(d => d.toString());
                        window.appInsights.trackException({
                            exception: new Error(`${message} ${dataPoints.join(',')}`)
                        });
                    }
                } catch {
                    // don't want to cause any weird errors to show up if we fail to track this execption
                }
            }
        }
    })(window.console.error);

    window.console.error = logError;
};

export const appInsights = window.appInsights;